import React, { useState, useEffect } from 'react';
import './Topo.css';
import logo from './Images/arcedesign-logo.png';

const Topo = () => {
  const [isHeaderVisible, setIsHeaderVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      // Pega a posição de rolagem atual
      const currentScrollY = window.scrollY;

      // Determina a direção da rolagem
      if (currentScrollY > lastScrollY && currentScrollY > 100) {
        // Se a rolagem for para baixo e já tiver passado 100px, esconde o cabeçalho
        setIsHeaderVisible(false);
      } else {
        // Se a rolagem for para cima, mostra o cabeçalho
        setIsHeaderVisible(true);
      }

      // Atualiza a posição de rolagem anterior
      setLastScrollY(currentScrollY);
    };

    // Adiciona o "event listener"
    window.addEventListener('scroll', handleScroll, { passive: true });

    // Remove o "event listener" ao desmontar o componente
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [lastScrollY]); // O efeito é reexecutado quando a posição de rolagem muda

  return (
    <header className={`main-header ${isHeaderVisible ? '' : 'hidden'}`}>
      <img src={logo} alt="Logo da Arce Design" className="company-logo" />
      <div className="company-info">
        <h1 className="company-name">Arce Design</h1>
        <p className="company-activities">Móveis Planejados - Projetos Integrados - Design de Interiores</p>
      </div>
    </header>
  );
};

export default Topo;